import type { FileVariant } from '@farol-ds/react'

const FRIENDLY_MIME_TYPES: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'text/plain': 'TXT',
  'text/csv': 'CSV',
  'text/xml': 'XML',
  'text/html': 'HTML',
  'text/markdown': 'MD',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/vnd.ms-word': 'DOC',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/vnd.ms-excel': 'XLS',
  'audio/ogg': 'OGG',
  'audio/webm': 'WEBM',
  'audio/m4a': 'M4A',
  'audio/x-m4a': 'M4A',
  'audio/m4v': 'M4V',
  'audio/mp3': 'MP3',
  'audio/mpeg': 'MP3',
  'audio/wav': 'WAV',
}

export function friendlyMimeType(mimeType: string) {
  return FRIENDLY_MIME_TYPES[mimeType] ?? 'Arquivo'
}

const MIME_TYPE_TO_FILE_VARIANT: Record<string, FileVariant> = {
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
}

export function mimeTypeToFileVariant(mimeType: string): FileVariant {
  return MIME_TYPE_TO_FILE_VARIANT[mimeType] ?? 'neutral'
}
